'use client';

import {
  LastSeenProductsRecoSlider,
  SearchTopsellerProductsRecoSlider,
  type PageTemplate,
} from '@packages/recommendations';
import { registerComponents } from '../ComponentRecognizer/componentRegistry';
import { ComponentTypes } from '../../../interfaces';
import type { EpsRecommendationType } from './types';
import { classes } from '../../utils/classes';

const Reco = ({
  data,
  pageTemplate,
  elementIndex = 0,
}: {
  data: EpsRecommendationType;
  elementIndex?: number;
  pageTemplate: PageTemplate;
}) => {
  const {
    field_reco_service_eps: recoServiceType,
    field_auto_headline_disabled: disableAutoHeadline,
  } = data;

  switch (recoServiceType) {
    case 'lastseen':
      return (
        <LastSeenProductsRecoSlider
          pageTemplate={pageTemplate}
          elementIndex={elementIndex}
          fetchOnThreshold
          title=""
          {...(disableAutoHeadline && { preferTitle: true })}
        />
      );
    case 'topseller':
      return (
        <SearchTopsellerProductsRecoSlider
          elementIndex={elementIndex}
          pageTemplate={pageTemplate}
          fetchOnThreshold
          title=""
          {...(disableAutoHeadline && { preferTitle: true })}
        />
      );
    default:
      return <span data-testid="cms-reco-no-reco-type-eps-found" />;
  }
};

export const CmsEpsRecommendation = ({
  data,
  recoIndex = 0,
  pageTemplate = 'homepage',
}: {
  data: EpsRecommendationType;
  recoIndex?: number;
  pageTemplate?: PageTemplate;
}) => {
  const { behavior_paragraph_outer_spacing: margin } = data;

  return (
    // use margin from cms. if no marging has been given by cms, set a margin-bottom of 8.
    <div className={classes(!margin && 'mb-8')} style={{ margin }}>
      <Reco data={data} pageTemplate={pageTemplate} elementIndex={recoIndex} />
    </div>
  );
};

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({ [ComponentTypes.RecoEps]: CmsEpsRecommendation });
